const BrowseCustomer = () => {
  return <></>;
};

export default BrowseCustomer;
